<div>
  <div class="d-flex flex-row align-items-center details">
    <a (click)="toggle()">
      <img src="./assets/ui/svg/grey/Icon-arrow-up.svg" [@rotate]="collapsed ? 'normal' : 'rotated'"><span *ngIf="!collapsed">See</span><span *ngIf="collapsed">Hide</span><span> details</span>
    </a>
  </div>

  <div [@stretchDown]="collapsed ? 'open' : 'close'" class="details-info">
    <h2 class="mb-1">Recipients:</h2>
    <div class="d-flex flex-column mb-3">
      <a *ngFor="let recipient of recipients" [href]="'mailto:'+recipient">{{recipient}}</a>
    </div>
    <h2 class="mb-1">Files:</h2>
    <div class="d-flex flex-column mb-3">
      <div *ngFor="let fileName of fileNames" class="d-flex">
        <img [src]="fileName.type === 'image' ? './assets/ui/svg/blue/image-icon.svg' : fileName.type === 'dicom' ? './assets/ui/svg/blue/dicom-icon.svg' : fileName.type === 'video' ? './assets/ui/svg/blue/video-icon.svg' : fileName.type === 'text' ? './assets/ui/svg/blue/text-icon.svg' : ''" class="small-file-type-icon">
        <span [matTooltip]="fileName.name" [matTooltipDisabled]="fileName.name.length < 20">{{fileName.name | slice: 0:20}}<span *ngIf="fileName.name.length > 20">...</span></span>
      </div>
    </div>
  </div>
</div>
